import {
    DeliveryDetailsModel,
    PlacedOrderModel,
    AddressSearchEditorModel,
    IlpQuestionDescriptions,
    IfcApplicationData
} from 'models';
import { BasketErrorModel } from 'models/Errors';
import {
    InitCheckoutPageAction,
    InitCheckoutPageActionStart,
    InitCheckoutPageActionSuccess,
    InitCheckoutPageActionError,
    UpdateDeliveryDetailsAction,
    UpdateDeliveryDetailsActionStart,
    UpdateDeliveryDetailsActionSuccess,
    UpdateDeliveryDetailsActionError,
    LoadDeliveryDetailsAction,
    LoadDeliveryDetailsActionStart,
    LoadDeliveryDetailsActionSuccess,
    LoadDeliveryDetailsActionError,
    UpdateDeliveryDetailsContactOptionsAction,
    UpdateDeliveryDetailsContactOptionsActionStart,
    UpdateDeliveryDetailsContactOptionsActionSuccess,
    UpdateDeliveryDetailsContactOptionsActionError,
    SetDeliverNotBeforeAction,
    SetDeliverNotBeforeActionError,
    SetDeliverNotBeforeActionStart,
    SetDeliverNotBeforeActionSuccess,
    CheckEmailAction,
    CheckEmailActionStart,
    CheckEmailActionSuccess,
    CheckEmailActionError,
    LoginProcessAction,
    LoginProcessActionStart,
    LoginProcessActionSuccess,
    LoginProcessActionError,
    LoginCredentialsErrorAction,
    RegisterProcessAction,
    RegisterProcessActionStart,
    RegisterProcessActionSuccess,
    RegisterProcessActionError,
    ClearEmailAction,
    ClearLoginAuthErrorsAction,
    ClearDeliverNotBeforeAction,
    ProcessOrderAction,
    ProcessOrderActionStart,
    ProcessOrderActionSuccess,
    ProcessOrderActionError,
    FindLastOrderActionStart,
    FindLastOrderActionSuccess,
    FindLastOrderActionError,
    PlaceOrderActionStart,
    PlaceOrderActionSuccess,
    PlaceOrderActionError,
    InitOrderSummaryPageAction,
    InitOrderSummaryPageActionStart,
    InitOrderSummaryPageActionSuccess,
    InitOrderSummaryPageActionError,
    PreprocessRedirectToNextStepAction,
    PreprocessRedirectToNextStepActionStart,
    PreprocessRedirectToNextStepActionSuccess,
    PreprocessRedirectToNextStepActionError,
    InitPaymentPageAction,
    InitPaymentPageActionStart,
    InitPaymentPageActionSuccess,
    InitPaymentPageActionError,
    TransferBasketAction,
    TransferBasketActionStart,
    TransferBasketActionSuccess,
    TransferBasketActionError,
    InitCompleteResetPasswordPageAction,
    InitCompleteResetPasswordPageActionStart,
    InitCompleteResetPasswordPageActionSuccess,
    InitCompleteResetPasswordPageActionError,
    PreprocessContinueDeliveryDateAction,
    PreprocessContinueDeliveryDateActionStart,
    PreprocessContinueDeliveryDateActionError,
    PreprocessContinueDeliveryDateActionSuccess
} from './actions';
import {
    ClearFinanceDataAction,
    InitFirstFinanceApplicationPageAction,
    InitFirstFinanceApplicationPageActionStart,
    InitFirstFinanceApplicationPageActionSuccess,
    InitFirstFinanceApplicationPageActionError,
    LoadQuestionSetAction,
    LoadQuestionSetActionError,
    LoadQuestionSetActionSuccess,
    InitIfcApplicationDataAction,
    InitIfcApplicationDataActionSuccess,
    InitIfcApplicationDataActionError,
    LoadQuestionSetActionStart,
    InitIfcApplicationDataActionStart,
    SetShowFinanceApplicationNotValidWarningAction
} from './actions/finance';
import {
    RemoveAddressSearchEditorAction,
    InitAddressSearchEditorAction,
    FindAddressAction,
    FindAddressActionStart,
    FindAddressActionSuccess,
    FindAddressActionError,
} from './actions/addressSearchEditor';
import { SaveIfcFinanceDataAction, SaveIfcFinanceDataActionError, SaveIfcFinanceDataActionStart, SaveIfcFinanceDataActionSuccess } from './actions/finance/saveIfcFinanceData';

export enum CheckoutActionTypes {
    LOAD_QUESTION_SET = 'checkout/LOAD_QUESTION_SET',
    LOAD_QUESTION_SET_START = 'checkout/LOAD_QUESTION_SET_START',
    LOAD_QUESTION_SET_SUCCESS = 'checkout/LOAD_QUESTION_SET_SUCCESS',
    LOAD_QUESTION_SET_ERROR = 'checkout/LOAD_QUESTION_SET_ERROR',

    LOAD_DELIVERY_DETAILS = 'checkout/LOAD_DELIVERY_DETAILS',
    LOAD_DELIVERY_DETAILS_START = 'checkout/LOAD_DELIVERY_DETAILS_START',
    LOAD_DELIVERY_DETAILS_SUCCESS = 'checkout/LOAD_DELIVERY_DETAILS_SUCCESS',
    LOAD_DELIVERY_DETAILS_ERROR = 'checkout/LOAD_DELIVERY_DETAILS_ERROR',

    LOGIN_PROCESS = 'checkout/LOGIN_PROCESS',
    LOGIN_PROCESS_START = 'checkout/LOGIN_PROCESS_START',
    LOGIN_PROCESS_SUCCESS = 'checkout/LOGIN_PROCESS_SUCCESS',
    LOGIN_PROCESS_ERROR = 'checkout/LOGIN_PROCESS_ERROR',
    LOGIN_CREDENTIALS_ERROR = 'checkout/LOGIN_CREDENTIALS_ERROR',

    INIT_CHECKOUT_PAGE = 'checkout/INIT_CHECKOUT_PAGE',
    INIT_CHECKOUT_PAGE_START = 'checkout/INIT_CHECKOUT_PAGE_START',
    INIT_CHECKOUT_PAGE_SUCCESS = 'checkout/INIT_CHECKOUT_PAGE_SUCCESS',
    INIT_CHECKOUT_PAGE_ERROR = 'checkout/INIT_CHECKOUT_PAGE_ERROR',

    INIT_ORDER_SUMMARY_PAGE = 'checkout/INIT_ORDER_SUMMARY_PAGE',
    INIT_ORDER_SUMMARY_PAGE_START = 'checkout/INIT_ORDER_SUMMARY_PAGE_START',
    INIT_ORDER_SUMMARY_PAGE_SUCCESS = 'checkout/INIT_ORDER_SUMMARY_PAGE_SUCCESS',
    INIT_ORDER_SUMMARY_PAGE_ERROR = 'checkout/INIT_ORDER_SUMMARY_PAGE_ERROR',

    INIT_PAYMENT_PAGE = 'checkout/INIT_PAYMENT_PAGE',
    INIT_PAYMENT_PAGE_START = 'checkout/INIT_PAYMENT_PAGE_START',
    INIT_PAYMENT_PAGE_SUCCESS = 'checkout/INIT_PAYMENT_PAGE_SUCCESS',
    INIT_PAYMENT_PAGE_ERROR = 'checkout/INIT_PAYMENT_PAGE_ERROR',

    CHECK_EMAIL = 'checkout/CHECK_EMAIL',
    CHECK_EMAIL_START = 'checkout/CHECK_EMAIL_START',
    CHECK_EMAIL_SUCCESS = 'checkout/CHECK_EMAIL_SUCCESS',
    CHECK_EMAIL_ERROR = 'checkout/CHECK_EMAIL_ERROR',
    CLEAR_EMAIL = 'checkout/CLEAR_EMAIL',
    CLEAR_LOGIN_AUTH_ERRORS = 'checkout/CLEAR_LOGIN_AUTH_ERRORS',

    REGISTER_PROCESS = 'checkout/REGISTER_PROCESS',
    REGISTER_PROCESS_START = 'checkout/REGISTER_PROCESS_START',
    REGISTER_PROCESS_SUCCESS = 'checkout/REGISTER_PROCESS_SUCCESS',
    REGISTER_PROCESS_ERROR = 'checkout/REGISTER_PROCESS_ERROR',

    SAVE_IFC_FINANCE_DATA = 'checkout/SAVE_IFC_FINANCE_DATA',
    SAVE_IFC_FINANCE_DATA_START = 'checkout/SAVE_IFC_FINANCE_DATA_START',
    SAVE_IFC_FINANCE_DATA_SUCCESS = 'checkout/SAVE_IFC_FINANCE_DATA_SUCCESS',
    SAVE_IFC_FINANCE_DATA_ERROR = 'checkout/SAVE_IFC_FINANCE_DATA_ERROR',

    CLEAR_FINANCE_DATA = 'checkout/CLEAR_FINANCE_DATA',

    SET_DELIVER_NOT_BEFORE = 'checkout/SET_DELIVER_NOT_BEFORE',
    SET_DELIVER_NOT_BEFORE_START = 'checkout/SET_DELIVER_NOT_BEFORE_START',
    SET_DELIVER_NOT_BEFORE_SUCCESS = 'checkout/SET_DELIVER_NOT_BEFORE_SUCCESS',
    SET_DELIVER_NOT_BEFORE_ERROR = 'checkout/SET_DELIVER_NOT_BEFORE_ERROR',
    CLEAR_DELIVER_NOT_BEFORE = 'checkout/CLEAR_DELIVER_NOT_BEFORE',

    UPDATE_DELIVERY_DETAILS = 'checkout/UPDATE_DELIVERY_DETAILS',
    UPDATE_DELIVERY_DETAILS_START = 'checkout/UPDATE_DELIVERY_DETAILS_START',
    UPDATE_DELIVERY_DETAILS_SUCCESS = 'checkout/UPDATE_DELIVERY_DETAILS_SUCCESS',
    UPDATE_DELIVERY_DETAILS_ERROR = 'checkout/UPDATE_DELIVERY_DETAILS_ERROR',

    UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS = 'checkout/UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS',
    UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_START = 'checkout/UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_START',
    UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_SUCCESS = 'checkout/UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_SUCCESS',
    UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_ERROR = 'checkout/UPDATE_DELIVERY_DETAILS_CONTACT_OPTIONS_ERROR',

    CONTINUE_FROM_DELIVERY_DATE = 'checkout/CONTINUE_FROM_DELIVERY_DATE',
    CONTINUE_FROM_DELIVERY_DATE_START = 'checkout/CONTINUE_FROM_DELIVERY_DATE_START',
    CONTINUE_FROM_DELIVERY_DATE_SUCCESS = 'checkout/CONTINUE_FROM_DELIVERY_DATE_SUCCESS',
    CONTINUE_FROM_DELIVERY_DATE_ERROR = 'checkout/CONTINUE_FROM_DELIVERY_DATE_ERROR',

    CONTINUE_FROM_DELIVERY_DETAILS = 'checkout/CONTINUE_FROM_DELIVERY_DETAILS',

    PROCESS_ORDER = 'checkout/PROCESS_ORDER',
    PROCESS_ORDER_START = 'checkout/PROCESS_ORDER_START',
    PROCESS_ORDER_SUCCESS = 'checkout/PROCESS_ORDER_SUCCESS',
    PROCESS_ORDER_ERROR = 'checkout/PROCESS_ORDER_ERROR',

    FIND_LAST_ORDER_START = 'checkout/FIND_LAST_ORDER_START',
    FIND_LAST_ORDER_SUCCESS = 'checkout/FIND_LAST_ORDER_SUCCESS',
    FIND_LAST_ORDER_ERROR = 'checkout/FIND_LAST_ORDER_ERROR',

    PLACE_ORDER_START = 'checkout/PLACE_ORDER_START',
    PLACE_ORDER_SUCCESS = 'checkout/PLACE_ORDER_SUCCESS',
    PLACE_ORDER_ERROR = 'checkout/PLACE_ORDER_ERROR',

    INIT_ADDRESS_SEARCH_EDITOR = 'checkout/INIT_ADDRESS_SEARCH_EDITOR',
    REMOVE_ADDRESS_SEARCH_EDITOR = 'checkout/REMOVE_ADDRESS_SEARCH_EDITOR',
    FIND_ADDRESS = 'checkout/FIND_ADDRESS',
    FIND_ADDRESS_START = 'checkout/FIND_ADDRESS_START',
    FIND_ADDRESS_SUCCESS = 'checkout/FIND_ADDRESS_SUCCESS',
    FIND_ADDRESS_ERROR = 'checkout/FIND_ADDRESS_ERROR',

    FINANCE_APPLICATION_TIMEOUT_ERROR = 'checkout/FINANCE_APPLICATION_TIMEOUT_ERROR',

    INIT_FIRST_FINANCE_APPLICATION_PAGE = 'checkout/INIT_FIRST_FINANCE_APPLICATION_PAGE',
    INIT_FIRST_FINANCE_APPLICATION_PAGE_START = 'checkout/INIT_FIRST_FINANCE_APPLICATION_PAGE_START',
    INIT_FIRST_FINANCE_APPLICATION_PAGE_SUCCESS = 'checkout/INIT_FIRST_FINANCE_APPLICATION_PAGE_SUCCESS',
    INIT_FIRST_FINANCE_APPLICATION_PAGE_ERROR = 'checkout/INIT_FIRST_FINANCE_APPLICATION_PAGE_ERROR',

    PREPROCESS_REDIRECT_TO_NEXT_STEP = 'checkout/PREPROCESS_REDIRECT_TO_NEXT_STEP',
    PREPROCESS_REDIRECT_TO_NEXT_STEP_START = 'checkout/PREPROCESS_REDIRECT_TO_NEXT_STEP_START',
    PREPROCESS_REDIRECT_TO_NEXT_STEP_SUCCESS = 'checkout/PREPROCESS_REDIRECT_TO_NEXT_STEP_SUCCESS',
    PREPROCESS_REDIRECT_TO_NEXT_STEP_ERROR = 'checkout/PREPROCESS_REDIRECT_TO_NEXT_STEP_ERROR',

    TRANSFER_BASKET = 'checkout/TRANSFER_BASKET',
    TRANSFER_BASKET_START = 'checkout/TRANSFER_BASKET_START',
    TRANSFER_BASKET_SUCCESS = 'checkout/TRANSFER_BASKET_SUCCESS',
    TRANSFER_BASKET_ERROR = 'checkout/TRANSFER_BASKET_ERROR',

    INIT_COMPLETE_RESET_PASSWORD_PAGE = 'checkout/INIT_COMPLETE_RESET_PASSWORD_PAGE',
    INIT_COMPLETE_RESET_PASSWORD_PAGE_START = 'checkout/INIT_COMPLETE_RESET_PASSWORD_PAGE_START',
    INIT_COMPLETE_RESET_PASSWORD_PAGE_SUCCESS = 'checkout/INIT_COMPLETE_RESET_PASSWORD_PAGE_SUCCESS',
    INIT_COMPLETE_RESET_PASSWORD_PAGE_ERROR = 'checkout/INIT_COMPLETE_RESET_PASSWORD_PAGE_ERROR',

    INIT_IFC_APPLICATION_DATA = 'checkout/INIT_IFC_APPLICATION_DATA',
    INIT_IFC_APPLICATION_DATA_START = 'checkout/INIT_IFC_APPLICATION_DATA_START',
    INIT_IFC_APPLICATION_DATA_SUCCESS = 'checkout/INIT_IFC_APPLICATION_DATA_SUCCESS',
    INIT_IFC_APPLICATION_DATA_ERROR = 'checkout/INIT_IFC_APPLICATION_DATA_ERROR',

    SET_SHOW_FINANCE_APPLICATION_NOT_VALID_WARNING = 'checkout/SET_SHOW_FINANCE_APPLICATION_NOT_VALID_WARNING',
}

export interface CheckoutState {
    isCheckoutPageInitializing: boolean;
    isPaymentPageInitializing: boolean;
    isPaymentPageInitialized: boolean;
    isOrderSummaryPageInitializing: boolean;
    deliveryDetails: DeliveryDetailsModel | null;
    isDeliveryDetailsLoading: boolean;
    isDeliveryDetailsUpdating: boolean;
    deliveryDetailsUpdatingErrors: BasketErrorModel[] | null;
    isUpdatingEca: boolean;
    deliverNotBefore: Date | null;
    selectedQuickestDeliveryDate: boolean;
    isCheckingEmail: boolean;
    userExists: boolean | null;
    userEmail: string | null;
    isAuthProcess: boolean;
    authErrors: BasketErrorModel | null;
    credentialErrors: BasketErrorModel | null;
    isOrderProcessing: boolean;
    isOrderPlacing: boolean;
    isLookingForLastOrder: boolean;
    processOrderError: BasketErrorModel | null;
    order: PlacedOrderModel | null;
    summaryPageError: BasketErrorModel | null;
    firstFinanceApplicationPageInitialized: boolean;
    addressSearchEditors: { [addressSearchEditorId: string]: AddressSearchEditorModel | undefined };
    isSubmitFinanceApplicationProcessing: boolean;
    submitFinanceApplicationError: BasketErrorModel | null;
    isCompleteResetPasswordPageInitializing: boolean;
    completeResetPasswordError: BasketErrorModel | null;
    ifcQuestionSet: IlpQuestionDescriptions | null;
    ifcApplicationData: IfcApplicationData | null;
    isIfcApplicationFilledByCustomer: boolean;
    shouldShowFinanceApplicationNotValidWarning: boolean;
    isContinueFromDeliveryDateProcessing: boolean;
}

export type CheckoutActions =
    LoadDeliveryDetailsAction
    | LoadDeliveryDetailsActionStart
    | LoadDeliveryDetailsActionSuccess
    | LoadDeliveryDetailsActionError
    | LoginProcessAction
    | LoginProcessActionStart
    | LoginProcessActionSuccess
    | LoginProcessActionError
    | LoginCredentialsErrorAction
    | InitCheckoutPageAction
    | InitCheckoutPageActionStart
    | InitCheckoutPageActionSuccess
    | InitCheckoutPageActionError
    | CheckEmailAction
    | CheckEmailActionStart
    | CheckEmailActionSuccess
    | CheckEmailActionError
    | ClearEmailAction
    | ClearLoginAuthErrorsAction

    | RegisterProcessAction
    | RegisterProcessActionStart
    | RegisterProcessActionSuccess
    | RegisterProcessActionError
    | SetDeliverNotBeforeAction
    | SetDeliverNotBeforeActionStart
    | SetDeliverNotBeforeActionSuccess
    | SetDeliverNotBeforeActionError
    | ClearDeliverNotBeforeAction
    | UpdateDeliveryDetailsAction
    | UpdateDeliveryDetailsActionStart
    | UpdateDeliveryDetailsActionSuccess
    | UpdateDeliveryDetailsActionError
    | UpdateDeliveryDetailsContactOptionsAction
    | UpdateDeliveryDetailsContactOptionsActionStart
    | UpdateDeliveryDetailsContactOptionsActionSuccess
    | UpdateDeliveryDetailsContactOptionsActionError
    | PreprocessContinueDeliveryDateAction
    | PreprocessContinueDeliveryDateActionStart
    | PreprocessContinueDeliveryDateActionSuccess
    | PreprocessContinueDeliveryDateActionError

    | ProcessOrderAction
    | ProcessOrderActionStart
    | ProcessOrderActionSuccess
    | ProcessOrderActionError

    | FindLastOrderActionStart
    | FindLastOrderActionSuccess
    | FindLastOrderActionError

    | PlaceOrderActionStart
    | PlaceOrderActionSuccess
    | PlaceOrderActionError

    | InitOrderSummaryPageAction
    | InitOrderSummaryPageActionStart
    | InitOrderSummaryPageActionSuccess
    | InitOrderSummaryPageActionError

    | SaveIfcFinanceDataAction
    | SaveIfcFinanceDataActionStart
    | SaveIfcFinanceDataActionSuccess
    | SaveIfcFinanceDataActionError

    | ClearFinanceDataAction

    | RemoveAddressSearchEditorAction
    | InitAddressSearchEditorAction
    | FindAddressAction
    | FindAddressActionStart
    | FindAddressActionSuccess
    | FindAddressActionError

    | InitFirstFinanceApplicationPageAction
    | InitFirstFinanceApplicationPageActionStart
    | InitFirstFinanceApplicationPageActionSuccess
    | InitFirstFinanceApplicationPageActionError

    | PreprocessRedirectToNextStepAction
    | PreprocessRedirectToNextStepActionStart
    | PreprocessRedirectToNextStepActionSuccess
    | PreprocessRedirectToNextStepActionError

    | InitPaymentPageAction
    | InitPaymentPageActionStart
    | InitPaymentPageActionSuccess
    | InitPaymentPageActionError

    | TransferBasketAction
    | TransferBasketActionStart
    | TransferBasketActionSuccess
    | TransferBasketActionError

    | InitCompleteResetPasswordPageAction
    | InitCompleteResetPasswordPageActionStart
    | InitCompleteResetPasswordPageActionSuccess
    | InitCompleteResetPasswordPageActionError

    | LoadQuestionSetAction
    | LoadQuestionSetActionStart
    | LoadQuestionSetActionSuccess
    | LoadQuestionSetActionError

    | InitIfcApplicationDataAction
    | InitIfcApplicationDataActionStart
    | InitIfcApplicationDataActionSuccess
    | InitIfcApplicationDataActionError

    | SetShowFinanceApplicationNotValidWarningAction;